import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useGlobalStore } from '../../../store'
import { Confirmation } from '../../../components'
import ProjectsService from '../../../services/projects.service'
import {
  Freeze,
  UnFreeze,
  Publish,
  UnPublish,
  EnableAskIa,
  DisableAskIa,
  AdminReview,
  UnAdminReview,
  EnableSnapshot,
  DisableSnapshot,
} from '../../../assets/images/icons'
import { ROLES_PUBLISHER, ROLES_MM_PRIMARY } from '../../../constants'
import IconsWrapper from '../../components/sidebar/iconWrapper'
import { getObjectAsArray } from '../../../util'
import DownloadCSV from '../../../pages/reports/headerButtons/download-csv'

const PublishProject = (props) => {
  const [confirmationVal, setConfirmationVal] = useState('')
  const [confirmationType, setConfirmationType] = useState('')
  const {projectIdValue, setProjectIdValue } = useGlobalStore()
  const {IsAskIAForStudy, IsSnapshotForStudy, IsFreezed, StudyId } = projectIdValue
  const [IsAdminReview, setIsAdminReview] = useState(null)
  const [IsPublished, setIsPublished] = useState(null)
  const [IsAskIA, setIsAskIA] = useState(null)
  const [IsSnapshot, setIsSnapshot] = useState(null)

  const getUpdatedProjectDatails = () => {
    ProjectsService.projectsDetailApi({ projectId: projectIdValue.ProjectId }, true)
      .then((resp) => {
        const obj = getObjectAsArray(resp).find(f => f.StudyId === StudyId)
        setIsPublished(obj.IsPublished)
        setIsAskIA(obj.IsAskIAEnabled)
        setIsSnapshot(obj.IsSnapshotEnabled)

        let aReview = !obj.IsPublished && obj.StudyStatus === 'AdminReview'
        let completed = obj.IsPublished // || obj.StudyStatus === 'Completed'
        setIsAdminReview(aReview)
        setIsPublished(completed)

        setProjectIdValue(obj)
      })
      .catch(() => {})
  }

  const PublishReport = () => {
    ProjectsService.projectsSetPublishStudy({ studyId: StudyId, publish: !IsPublished })
      .then(() => {
        setConfirmationType(null)
        //
        getUpdatedProjectDatails()
      })
      .catch((error) => {
        console.log('ERROR : ', error)
      })
  }

  const FreezeReport = () => {
    ProjectsService.projectsSetFreezeStudy({ studyId: StudyId, freeze: !IsFreezed })
      .then(() => {
        setConfirmationType(null)
        //
        getUpdatedProjectDatails()
      })
      .catch((error) => {
        console.log('ERROR : ', error)
      })
  }

  const AdminReviewReport = () => {
    ProjectsService.projectsSetAdminReviewStudy({ studyId: StudyId, adminReview: !IsAdminReview })
      .then(() => {
        // const data = {
        //   ...projectIdValue,
        //   StudyStatus: projectIdValue.StudyStatus === 'AdminReview' ? 'InProgress' : 'AdminReview',
        // }
        // setProjectIdValue(data)
        setConfirmationType(null)
        //
        getUpdatedProjectDatails()
      })
      .catch((error) => {
        console.log('ERROR : ', error)
      })
  }

  const AskIAReport = () => {
    ProjectsService.projectsSetAskIAForStudy({ studyId: StudyId, askIA: !IsAskIAForStudy })
      .then(() => {
        setConfirmationType(null)
        //
        getUpdatedProjectDatails()
      })
      .catch((error) => {
        console.log('ERROR : ', error)
      })
  }

  const SnapshotReport = () => {
    ProjectsService.projectsSetSnapshotForStudy({ studyId: StudyId, snapshot: !IsSnapshotForStudy })
      .then(() => {
        setConfirmationType(null)
        //
        getUpdatedProjectDatails()
      })
      .catch((error) => {
        console.log('ERROR : ', error)
      })
  }

  useEffect(() => {
    let aReview = !projectIdValue.IsPublished && projectIdValue.StudyStatus === 'AdminReview'
    let completed = projectIdValue.IsPublished // || projectIdValue.StudyStatus === 'Completed'

    setIsAdminReview(aReview)
    setIsPublished(completed)
  }, [projectIdValue])

  return (
    <>

      {ROLES_MM_PRIMARY.includes(props.userType) && (
        <DownloadCSV />
      )}

      {[ROLES_PUBLISHER].includes(props.userType) && !IsAdminReview && (
        <IconsWrapper
          title='Admin Review'
          onClick={() => {
            setConfirmationType('admintreview')
            setConfirmationVal('admintreview')
          }}
        >
          <AdminReview />
        </IconsWrapper>
      )}
      {[ROLES_PUBLISHER].includes(props.userType) && IsAdminReview && (
        <IconsWrapper
          title='Un Admin Review'
          onClick={() => {
            setConfirmationType('unadmintreview')
            setConfirmationVal('unadmintreview')
          }}
        >
          <UnAdminReview />
        </IconsWrapper>
      )}

      {[ROLES_PUBLISHER].includes(props.userType) && !IsPublished && (
        <IconsWrapper
          title='Publish'
          onClick={() => {
            setConfirmationType('publish')
            setConfirmationVal('publish')
          }}
        >
          <Publish />
        </IconsWrapper>
      )}
      {[ROLES_PUBLISHER].includes(props.userType) && IsPublished && (
        <IconsWrapper
          title='Unpublish'
          onClick={() => {
            setConfirmationType('publish')
            setConfirmationVal('unpublish')
          }}
        >
          <UnPublish />
        </IconsWrapper>
      )}
      {[ROLES_PUBLISHER].includes(props.userType) && !IsFreezed && (
        <IconsWrapper
          title='Freeze'
          onClick={() => {
            setConfirmationType('freeze')
            setConfirmationVal('Freeze')
          }}
        >
          <Freeze />
        </IconsWrapper>
      )}
      {[ROLES_PUBLISHER].includes(props.userType) && IsFreezed && (
        <IconsWrapper
          title='Un Freeze'
          onClick={() => {
            setConfirmationType('freeze')
            setConfirmationVal('Unfreeze')
          }}
        >
          <UnFreeze />
        </IconsWrapper>
      )}

      {[ROLES_PUBLISHER].includes(props.userType) && !IsAskIAForStudy && (
        <IconsWrapper
          title='Enable AskIA'
          onClick={() => {
            setConfirmationType('enableAskIA')
            setConfirmationVal('enableAskIA')
          }}
          sx={{ marginLeft: '10px' }}
        >
          <EnableAskIa />
        </IconsWrapper>
      )}
      {[ROLES_PUBLISHER].includes(props.userType) && IsAskIAForStudy && (
        <IconsWrapper
          title='Disable AskIA'
          onClick={() => {
            setConfirmationType('disableAskIA')
            setConfirmationVal('disableAskIA')
          }}
          sx={{ marginLeft: '10px' }}
        >
          <DisableAskIa />
        </IconsWrapper>
      )}

      {[ROLES_PUBLISHER].includes(props.userType) && !IsSnapshotForStudy && (
        <IconsWrapper
          title='Enable Snapshot'
          onClick={() => {
            setConfirmationType('enableSnapshot')
            setConfirmationVal('enableSnapshot')
          }}
          sx={{ marginLeft: '10px' }}
        >
          <EnableSnapshot />
        </IconsWrapper>
      )}
      {[ROLES_PUBLISHER].includes(props.userType) && IsSnapshotForStudy && (
        <IconsWrapper
          title='Disable Snapshot'
          onClick={() => {
            setConfirmationType('disableSnapshot')
            setConfirmationVal('disableSnapshot')
          }}
          sx={{ marginLeft: '10px' }}
        >
          <DisableSnapshot />
        </IconsWrapper>
      )}

      {confirmationType === 'publish' && (
        <Confirmation
          open={true}
          title={`Are you sure you want to ${confirmationVal} the study?`}
          onCancel={() => setConfirmationType(null)}
          // cancelMsg={'No'}
          onSubmit={PublishReport}
          // submitMsg={'Yes'}
          // showSubmitMsg={false}
        />
      )}
      {confirmationType === 'publish' && (
        <Confirmation
          open={true}
          title={`Are you sure you want to ${confirmationVal} the study?`}
          onCancel={() => setConfirmationType(null)}
          // cancelMsg={'No'}
          onSubmit={PublishReport}
          // submitMsg={'Yes'}
          // showSubmitMsg={false}
        />
      )}
      {confirmationType === 'freeze' && (
        <Confirmation
          open={true}
          title={`Are you sure you want to ${confirmationVal} the study?`}
          onCancel={() => setConfirmationType(null)}
          // cancelMsg={'No'}
          onSubmit={FreezeReport}
          // submitMsg={'Yes'}
          // showSubmitMsg={false}
        />
      )}
      {confirmationType === 'admintreview' && (
        <Confirmation
          open={true}
          title={`Are you sure you want to move the study under review?`}
          onCancel={() => setConfirmationType(null)}
          // cancelMsg={'No'}
          onSubmit={AdminReviewReport}
          // submitMsg={'Yes'}
          // showSubmitMsg={false}
        />
      )}
      {confirmationType === 'unadmintreview' && (
        <Confirmation
          open={true}
          title={`Are you sure you want to move the study back to In Progress?`}
          onCancel={() => setConfirmationType(null)}
          // cancelMsg={'No'}
          onSubmit={AdminReviewReport}
          // submitMsg={'Yes'}
          // showSubmitMsg={false}
        />
      )}
      {confirmationType === 'enableAskIA' && (
        <Confirmation
          open={true}
          title={`Are you sure you want to enable the Ask IA?`}
          onCancel={() => setConfirmationType(null)}
          // cancelMsg={'No'}
          onSubmit={AskIAReport}
          // submitMsg={'Yes'}
          // showSubmitMsg={false}
        />
      )}
      {confirmationType === 'disableAskIA' && (
        <Confirmation
          open={true}
          title={`Are you sure you want to disable the Ask IA?`}
          onCancel={() => setConfirmationType(null)}
          // cancelMsg={'No'}
          onSubmit={AskIAReport}
          // submitMsg={'Yes'}
          // showSubmitMsg={false}
        />
      )}
      {confirmationType === 'enableSnapshot' && (
        <Confirmation
          open={true}
          title={`Are you sure you want to enable the Snapshot?`}
          onCancel={() => setConfirmationType(null)}
          // cancelMsg={'No'}
          onSubmit={SnapshotReport}
          // submitMsg={'Yes'}
          // showSubmitMsg={false}
        />
      )}
      {confirmationType === 'disableSnapshot' && (
        <Confirmation
          open={true}
          title={`Are you sure you want to disable the Snapshot?`}
          onCancel={() => setConfirmationType(null)}
          // cancelMsg={'No'}
          onSubmit={SnapshotReport}
          // submitMsg={'Yes'}
          // showSubmitMsg={false}
        />
      )}
    </>
  )
}

export default PublishProject

PublishProject.propTypes = {
  userType: PropTypes.string,
  projectIdValue: PropTypes.object,
  setProjectIdValue: PropTypes.func,
}

PublishProject.defaultProps = {
  userType: '',
  projectIdValue: {},
  setProjectIdValue: () => {},
}
